import { ToolPageShell } from '@/shared/seo'
import { RazdelitPdfForm } from './RazdelitPdfForm'

export function RazdelitPdfPage() {
  return (
    <ToolPageShell utilityKey="splitPdf">
      <RazdelitPdfForm />
    </ToolPageShell>
  )
}
